import { IExecutionOptions, IQueryOptions } from '../../models/query';
import { BaseTransform } from './BaseTransform';
import { Query } from '../Query';
import { deepMergeObjects } from '../../utils/object';
import { ITransformCollectionField } from '../../models/query/transforms/ITransformCollectionField';
import { isNullOrUndefined } from '../../utils/typeChecks';

export class CollectionTransform extends BaseTransform {
	execute(queryResponse: any[], queryOptions: IQueryOptions, executionOptions: IExecutionOptions) {
		let response: any[] = [];
		const { fields: parentOptionsFields, collectionTransformOptions = {} } = this.options;
		if (queryResponse) {
			const fields = collectionTransformOptions.fields || parentOptionsFields || [];
			const { singleFieldValueKey, type = 'standard', mergeKey } = collectionTransformOptions;
			const hasSingleFieldValueKey = singleFieldValueKey && singleFieldValueKey.length > 0;
			if (type === 'standard') {
				for (const queryResponseRow of queryResponse) {
					const row: object = { ...queryResponseRow };
					const workingExecutionOptions = deepMergeObjects(executionOptions, { responseContext: row } as Partial<IExecutionOptions>);
					for (const field of fields) {
						const { key: originalKey, query, keyQuery: keyQueryOptions } = field as ITransformCollectionField;
						let key = originalKey;
						if (!originalKey && keyQueryOptions) {
							const keyQuery = new Query(keyQueryOptions);
							key = keyQuery.execute(workingExecutionOptions);
						}
						if (!hasSingleFieldValueKey || singleFieldValueKey === key) {
							if (query) {
								const valueQuery = new Query(query);
								const value = valueQuery.execute(workingExecutionOptions);
								row[key] = value;
							}
						}
					}
					response.push(row);
				}
				if (hasSingleFieldValueKey) {
					response = response.map(row => row[singleFieldValueKey]);
				}
			}
			if (type === 'merge' && mergeKey) {
				const rowByKey = queryResponse.reduce((acc, row) => {
					const keyValue = row[mergeKey];
					if (!isNullOrUndefined(keyValue)) {
						acc[keyValue] = deepMergeObjects(acc[keyValue] || {}, row);
					}
					return acc;
				}, {});
				response = Object.values(rowByKey);
			}
			if (type === 'flatten') {
				response = queryResponse.reduce((acc, row) => {
					if (Array.isArray(row)) {
						acc.push(...row);
					}
					else {
						acc.push(row);
					}
					return acc;
				}, []);
			}
		}
		return response;
	}
}